// Avvisa il menu (badge Documenti) che i documenti da firmare o compilare sono cambiati.
export const DOCUMENTS_CHANGED_EVENT = 'heyjobDocumentsChanged';

export const notifyDocumentsChanged = () => window.dispatchEvent(new Event(DOCUMENTS_CHANGED_EVENT));
